"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSso(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-5.017 0-9 3.983-9 9 0 5.017 3.983 9 9 9 5.017 0 9-3.983 9-9 0-5.017-3.983-9-9-9zM2 12C2 6.431 6.431 2 12 2s10 4.431 10 10-4.431 10-10 10S2 17.569 2 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.583 9.5a3.416 3.416 0 115.232 2.89l.762 4.95a.5.5 0 01-.494.577H9.917a.5.5 0 01-.495-.576l.762-4.95a3.409 3.409 0 01-1.6-2.891zM12 7.083a2.416 2.416 0 00-1.051 4.59.5.5 0 01.276.526l-.726 4.718H13.5l-.726-4.718a.5.5 0 01.276-.526A2.414 2.414 0 0012 7.083z"
  }));
}

var _default = SvgSso;
exports["default"] = _default;